var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2727 23.9404V17.5827C16.2727 17.3016 16.1578 17.0321 15.9532 16.8334C15.7486 16.6347 15.4711 16.5231 15.1818 16.5231H10.8182C10.5289 16.5231 10.2514 16.6347 10.0468 16.8334C9.84221 17.0321 9.72727 17.3016 9.72727 17.5827V23.9404C9.72727 24.2214 9.61234 24.4909 9.40775 24.6896C9.20317 24.8884 8.92569 25 8.63636 25H2.09091C1.80158 25 1.52411 24.8884 1.31952 24.6896C1.11493 24.4909 1 24.2214 1 23.9404V11.6886C1.00244 11.5419 1.03507 11.3972 1.09596 11.263C1.15685 11.1288 1.24477 11.0078 1.35455 10.9071L12.2636 1.27781C12.4647 1.09911 12.7274 1 13 1C13.2726 1 13.5353 1.09911 13.7364 1.27781L24.6455 10.9071C24.7552 11.0078 24.8432 11.1288 24.904 11.263C24.9649 11.3972 24.9976 11.5419 25 11.6886V23.9404C25 24.2214 24.8851 24.4909 24.6805 24.6896C24.4759 24.8884 24.1984 25 23.9091 25H17.3636C17.0743 25 16.7968 24.8884 16.5922 24.6896C16.3877 24.4909 16.2727 24.2214 16.2727 23.9404Z",
    stroke: "#8879A5",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home_icon.26e267a0875b4fd466022a6df8f6051c.svg";
export { ForwardRef as ReactComponent };